import { getDateToJalaaliWithDash, getRangeDates, monthDiff } from '../../utils/dateTimeUtil';
import { getSettingItem } from '../../utils/storage';

const getYearAndMonth = (val) => {
    const date = val;
    return date?.slice(0, 7);
};

const sumSameMonth = (data) => {
    return data.reduce((acc, cur) => {
        const item =
            acc.length > 0 &&
            acc.find(({ date }) => getYearAndMonth(date) === getYearAndMonth(cur.date));
        if (item) {
            item.count += cur.count;
        } else
            acc.push({
                date: cur.date,
                count: cur.count
            });
        return acc;
    }, []);
};

export const concatZeroCountWithData = (val, d1, d2) => {
    const lang = getSettingItem('lang');
    // let start;
    // let end;
    let payload;
    const diff = monthDiff(d1, d2);

    if (lang === 'fa' && diff > 3) {
        // start = getDateToJalaaliWithDash(d1);
        // end = getDateToJalaaliWithDash(d2);
        payload = val?.map((item) => ({
            count: item.count,
            date: getDateToJalaaliWithDash(item.date)
        }));
    } else {
        // start = d1;
        // end = d2;
        payload = val;
    }
    let data = [...payload];
    const rangeDates = getRangeDates(d1, d2, lang === 'fa' && diff > 3);

    const missingDate = rangeDates.filter((item) => !data.find((arr) => arr.date === item));
    missingDate.forEach((f) => (data = [...data, { date: f, count: 0 }]));
    if (diff > 3) {
        return sumSameMonth(data).sort((a, b) => new Date(a.date) - new Date(b.date));
    } else {
        return data.sort((a, b) => new Date(a.date) - new Date(b.date));
    }
};
